import {
  CLASSIFIED_ADS_PATH,
  CLASSIFIED_AD_DETAIL_PATH,
  EDIT_CLASSIFIED_AD_PATH,
  MY_CLASSIFIED_AD_MESSAGE_PATH,
  MY_CLASSIFIED_ADS_MESSAGES_PATH,
  MY_CLASSIFIED_ADS_PATH,
  NEW_CLASSIFIED_AD_PATH,
} from "@/features/classified-ads/configs/classifiedAdsPaths.config";
import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const ClassifiedAdsPage = lazyWithRetry(() => import("@/features/classified-ads/pages/ClassifiedAdsPage"));
const ClassifiedAdDetailPage = lazyWithRetry(() => import("@/features/classified-ads/pages/ClassifiedAdDetailPage"));
const ClassifiedAdFormPage = lazyWithRetry(() => import("@/features/classified-ads/pages/ClassifiedAdFormPage"));
const MyClassifiedAdsPage = lazyWithRetry(() => import("@/features/classified-ads/pages/MyClassifiedAdsPage"));
const ClassifiedAdsMessagesPage = lazyWithRetry(() => import("@/features/classified-ads/pages/ClassifiedAdsMessagesPage"));

const classifiedAdsRoutes: RouteConfig[] = [
  {
    path: CLASSIFIED_ADS_PATH,
    element: <ClassifiedAdsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: MY_CLASSIFIED_ADS_PATH,
    element: <MyClassifiedAdsPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: MY_CLASSIFIED_ADS_MESSAGES_PATH,
    element: <ClassifiedAdsMessagesPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: MY_CLASSIFIED_AD_MESSAGE_PATH,
    element: <ClassifiedAdsMessagesPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: NEW_CLASSIFIED_AD_PATH,
    element: <ClassifiedAdFormPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: EDIT_CLASSIFIED_AD_PATH,
    element: <ClassifiedAdFormPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: CLASSIFIED_AD_DETAIL_PATH,
    element: <ClassifiedAdDetailPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default classifiedAdsRoutes;
